export const FULLSTORY_EXCLUDE_CLASS_NAME = 'fs-exclude';
